import { Summary } from '@elements/summary'
import { H3 } from '@elements/headings'
import { FormattedContent } from '@elements/formatted-content'

import { InventoryItem, Venue } from 'types/model'
import { InventoryCard } from './inventory-card'
import { InventorySubtotalDisplay } from './inventory-subtotal-display'

export interface InventoryDetailDisplayProps {
  inventory?: InventoryItem
  venue?: Venue
  quantity: number | null | undefined
  setQuantity: (val: number | null | undefined) => void
}

export function InventoryDetailDisplay({
  venue,
  inventory,
  quantity,
  setQuantity,
}: InventoryDetailDisplayProps) {
  const isTicket = inventory?.type === 'TICKET'
  const terms = isTicket ? venue?.ticketTerms : venue?.tableTerms

  return (
    <div className='w-full px-3 pt-6 space-y-6 sm:px-6'>
      {inventory && venue && (
        <>
          <H3>You&apos;ve Selected:</H3>
          <div className='space-y-2'>
            {inventory.type === 'PACKAGE' &&
            venue.inventoryTableSubtotalPreviews ? (
              <InventorySubtotalDisplay
                inventory={inventory}
                venue={venue}
                quantity={quantity}
              />
            ) : (
              <InventoryCard
                mode='multiply'
                onMultiply={setQuantity}
                inventory={inventory}
                quantity={quantity}
                venue={venue}
              />
            )}
          </div>
          <div className='space-y-2'>
            {inventory.description && (
              <Summary title='Details' initiallyOpen>
                <FormattedContent>{inventory.description}</FormattedContent>
              </Summary>
            )}
            <Summary title={`${isTicket ? 'Ticket' : ''} Terms & Conditions`}>
              <FormattedContent>
                {(inventory.termsAndConditions || terms) ?? ''}
              </FormattedContent>
            </Summary>
          </div>
        </>
      )}
    </div>
  )
}
